import * as React from 'react';
import {withStyles, WithStyles} from '@material-ui/core';
import { ChatStyle } from './Chat.style';


interface IProps extends WithStyles<typeof ChatStyle> {
  back: () => void;
  pane: React.RefObject<HTMLDivElement>;
  chatId?:number;
}

class BackSwipe extends React.Component<IProps> {
  private paneStart: number = 0;
  private paneLeft:number = 0;
  private paneShiftTime:number = 0;
  private inSwiping:boolean = false;

  constructor(props: IProps) {
    super(props);
  }

  public componentDidMount() {
    this.paneShiftTime = this.props.chatId !== undefined ? Date.now() : 0;
  }

  public componentDidUpdate(prevProps:IProps) {
    if (this.props.chatId !== prevProps.chatId) {
      this.paneShiftTime = this.props.chatId !== undefined ? Date.now() : 0;
      this.inSwiping = false;
      this.paneLeft = 0;
      if (this.props.pane.current) {
        this.props.pane.current.style.removeProperty('transition');
      }
    }
  }

  public render() {
    const {classes, back, } = this.props;
    
    return (
      <div className={classes.backSwipe} 
        onTouchStart={(evt) => this.touchStart(evt)}
        onTouchCancel={(evt) => this.touchEnd(evt, true)}
        onTouchEnd={(evt) => this.touchEnd(evt)}
        onTouchMove={(evt) => this.touchMove(evt)}
      />

    );
  }

  private touchStart(e:React.TouchEvent<HTMLDivElement>) {
    if (this.paneShiftTime !== 0 && Date.now() > this.paneShiftTime + 500) {
      this.inSwiping = true;
      this.paneStart = e.touches[0].screenX;
      if (this.props.pane.current) {
        this.props.pane.current.style.transition = "unset";
      }
    }
  }

  private touchEnd(e:React.TouchEvent<HTMLDivElement>, cancelled:boolean = false) {
    
    if (this.inSwiping) {
      this.inSwiping = false;
      this.paneStart=0;
      if (this.props.pane.current) {
        this.props.pane.current.style.removeProperty('transition');
        if (cancelled || this.paneLeft > -130) {
          this.props.pane.current.style.transform = "translate3d(0, 0, 0)";
          this.paneLeft = 0;
          this.paneStart = 0;
        } else {
          this.props.pane.current.style.transform = "translate3d(100%, 0, 0)";
          this.props.back();
          this.paneLeft = 0;
          this.paneStart = 0;
        }
      }
    }
  }

  private touchMove(e:React.TouchEvent<HTMLDivElement>) {
    if (this.inSwiping) {
      const newX = e.touches[0].screenX;
      const delta =  this.paneStart - newX;

      if (this.props.pane.current) {
        const paneLeft:number = this.paneLeft + delta; 

        if (this.paneLeft !== paneLeft) {
          this.paneLeft = paneLeft;
          this.paneStart = newX;
          let left = -paneLeft;
          if (left < 0) {left = 0}
          this.props.pane.current.style.transform = `translate3d(${left}px, 0, 0)`;
        }
      }
    }
  }


}


export default (withStyles(ChatStyle)(BackSwipe));



// WEBPACK FOOTER //
// ./src/components/chat/BackSwipe.tsx